import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { usePrevious } from 'src/hooks/usePrevious'

import { useStepper } from './StepperProvider'

export const Step = () => {
  const router = useRouter()
  const { step, onReset } = useStepper()
  useEffect(() => {
    // Defaults view to top of page whenever the step changes
    window.scrollTo(0, 0)
  }, [step])

  const prevPathname = usePrevious(router.pathname)

  // Resets the form when the user navigates to a different page
  // NOTE: This is a workaround for the fact that the form is not
  // reset on submission which formik usually handles
  useEffect(() => {
    if (prevPathname) {
      if (router.pathname !== prevPathname && onReset) {
        onReset()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevPathname])

  const StepComponent = step.component

  return <StepComponent />
}
